import React from 'react';
import { useNavigate } from 'react-router-dom';
import CreateProject from './createProject/createProject';

const CreateProjectWrapper = ({ setShowCreate, setProjectArr, setProjectNow, projectArr }) => {
  const navigate = useNavigate();

  const handleEmit = (name, canvasStyle) => {
    if (name && canvasStyle) {
      let newName = name;
      let num = 1;
      while (projectArr.some(item => item.name === newName)) {
        newName = `${name}(${num})`;
        num++;
      }
      let newProjectArr = [...projectArr, { name: newName, canvasStyle }];
      setProjectArr(newProjectArr);
      setProjectNow({ name: newName, canvasStyle });
      setShowCreate(false);
      navigate(`/${newName}`);
    } else {
      setShowCreate(false);
    }
  };

  return (
    <div className="create">
      <CreateProject data={handleEmit} />
    </div>
  );
};

export default CreateProjectWrapper;
